module.exports = __webpack_public_path__ + "static/img/y12.0a7011c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y12.jpg
// module id = WoZU
// module chunks = 1